import { ExclamationCircleOutlined } from '@ant-design/icons';
import confirm from 'antd/lib/modal/confirm';
import { useToast } from '@quinyx/ui';

import AdminForm from '../../../forms/admin';
import { handleError } from '../../../api/utils';
import { useCreateAdmin } from '../../../hooks/admin';
import { withAdminLayout } from '../../../layouts/admin';
import { useTranslate } from '../../../hooks/translate';

const CreateAdmin = () => {
  const { createAdmin, validateEmail, isLoading } = useCreateAdmin();
  const createToast = useToast();
  const { t } = useTranslate();

  const onSubmit = async ({ email }: { email: string }) => {
    try {
      await validateEmail(email);
      confirm({
        title: t('admin.createSystemAdmin'),
        content: <p>{t('admin.createSystemAdminConfirm', { email })}</p>,
        icon: <ExclamationCircleOutlined />,
        okText: t('common.yes'),
        cancelText: t('common.no'),
        onOk: async () => {
          await createAdmin(email);
          createToast({
            message: t('toast.systemAdminCreated'),
            type: 'positive',
          });
        },
      });
    } catch (error) {
      handleError(error);
    }
  };

  return (
    <AdminForm
      formTitle={t('admin.createSystemAdmin')}
      formDescription={t('admin.systemAdminAccessNote')}
      onSubmit={onSubmit}
      buttonText={t('common.create')}
      isLoading={isLoading}
    />
  );
};

export default withAdminLayout(CreateAdmin);
